import { FC, SVGAttributes } from "react";

const MaestroIconBackground: FC<SVGAttributes<SVGSVGElement>> = ({
  width = 32,
  height = 24,
  ...props
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 32 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <title>Maestro</title>
    <path
      d="M4.12903 0.5H27.871C29.8701 0.5 31.5 2.13976 31.5 4.17391V19.8261C31.5 21.8602 29.8701 23.5 27.871 23.5H4.12903C2.12986 23.5 0.5 21.8602 0.5 19.8261V4.17391C0.5 2.13976 2.12986 0.5 4.12903 0.5Z"
      fill="white"
      stroke="#EEEEEE"
    />
    <path
      d="M12.9032 17.2174C15.7537 17.2174 18.0645 14.8815 18.0645 12C18.0645 9.1185 15.7537 6.78259 12.9032 6.78259C10.0527 6.78259 7.74194 9.1185 7.74194 12C7.74194 14.8815 10.0527 17.2174 12.9032 17.2174Z"
      fill="#E7001A"
    />
    <path
      d="M19.0968 17.2174C21.9473 17.2174 24.2581 14.8815 24.2581 12C24.2581 9.1185 21.9473 6.78259 19.0968 6.78259C16.2463 6.78259 13.9355 9.1185 13.9355 12C13.9355 14.8815 16.2463 17.2174 19.0968 17.2174Z"
      fill="#00A2E1"
    />
    <path
      opacity="0.3"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16 7.82568C17.2536 8.77755 18.0645 10.293 18.0645 12C18.0645 13.7069 17.2536 15.2224 16 16.1743C14.7464 15.2224 13.9355 13.7069 13.9355 12C13.9355 10.293 14.7464 8.77755 16 7.82568Z"
      fill="#E7001A"
    />
  </svg>
);

export default MaestroIconBackground;
